'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _xhr = require('./xhr2');

var _xhr2 = _interopRequireDefault(_xhr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PROJECTNAME = 'whereami';
var BASESAMPLE = 0.5; // 组件内置的日志上报率
var FILTERCODE = [201, 409, 416]; // 需要过滤的code

var Log = function () {
    function Log() {
        _classCallCheck(this, Log);

        this.stack = []; // 初始化Log栈队列(异步模式下暂存日志对象)
        this.initSDK();
        this.debug = /debug/i.test(location.search);

        /**
         * 组件级tag, `清洗`脏数据
         * `new`: v2.0.5 - v2.0.7
         * `stage`: v2.0.8 - latest
         */
        this.defaultTag = 'stage';

        this.normalPrefix = 'whereami-type-' + (this.debug ? 'debug-' : '');
        this.errorPrefix = 'whereami-fail-' + (this.debug ? 'debug-' : '');
    }

    _createClass(Log, [{
        key: 'initSDK',
        value: function initSDK() {
            var _this = this;

            var Owl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.Owl;

            if (!Owl) {
                // 异步加载npm版本owl
                return require.ensure([], function () {
                    _this.debug && console.log('load owl async');
                    Owl = require('@dp/owl');
                    _this.initSDK(Owl);
                    _this.dispatch();
                }, 'whereami-owl');
            }
            this.owl = new Owl.OWL({
                devMode: /51ping.com/i.test(location.hostname),
                project: PROJECTNAME,
                resource: {
                    sampleApi: 1 // 说明：实际采样率由`this.sampleValid`控制
                }
            });
        }
    }, {
        key: 'initData',
        value: function initData() {
            var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.stack = [];
            this.source = _config2.default.get('source').trim();
            this.sample = _config2.default.get('sampling');
            opt.normalPrefix && (this.normalPrefix = opt.normalPrefix);
            opt.errorPrefix && (this.errorPrefix = opt.errorPrefix);
            // 上报率控制阀：针对一次完整调用
            this.random = Math.random();
            this.sampleValid = this.randomSample(BASESAMPLE); // 组件级开关，上报率内置
            this.customSampleValid = !!this.source && this.randomSample(this.sample); // 自定义业务开关
        }
    }, {
        key: 'dispatch',
        value: function dispatch() {
            var _this2 = this;

            this.stack.map(function (log) {
                if (log.type == 'err') {
                    _this2.logError.apply(_this2, log.params);
                } else {
                    _this2.log.apply(_this2, log.params);
                }
            });
        }
        /**
         * API上报: 渠道成功率
         * @param {*} startTime 
         * @param {*} isSuccess 
         * @param {*} type 
         * @param {*} name 
         * @param {*} endTime 
         */

    }, {
        key: 'log',
        value: function log() {
            var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
            var name = arguments[3];
            var endTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Date.now();

            if (!!~FILTERCODE.indexOf(code) || !(this.sampleValid || this.customSampleValid)) return;
            name = name || this.normalPrefix + type; // 默认用渠道名, 接受自定义(某些特殊的地方，组件级)
            if (!this.owl) {
                // stack
                return this.stack.push({
                    params: [startTime, code, type, name, endTime] // 手动填充: 新增endTime，并向前兼容
                });
            }
            code = code == true ? 200 : code == false ? 500 : code; // 状态码：向前兼容
            // 组件统计
            this.sampleValid && this.owl.addApi({
                name: this.withTag(name, this.defaultTag),
                statusCode: code,
                responseTime: endTime - startTime // 时间
            });
            // 业务统计
            this.customSampleValid && this.owl.addApi({
                name: this.withTag(name, this.source),
                statusCode: code,
                responseTime: endTime - startTime
            });
        }
        /**
         * 错误详情上报
         * @param {*} err 
         * @param {*} type 
         * @param {*} name 
         */

    }, {
        key: 'logError',
        value: function logError() {
            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
            var name = arguments[2];

            if (!this.sampleValid && !this.customSampleValid) return; // v2.1 开始与`log`同比采样
            name = name || this.errorPrefix + type;
            if (!this.owl) {
                // stack
                return this.stack.push({
                    type: 'err',
                    params: arguments
                });
            }
            // 组件统计
            this.sampleValid && this.owl.addError({
                name: this.withTag(name, this.defaultTag),
                msg: err.message
            });
            // TEST: 业务统计
            // this.customSampleValid && this.owl.addError({
            //     name: this.withTag(this.errorPrefix + type, this.source),
            //     msg: err.message
            // })
        }
        /**
         * 定位成功结果上报（统计服务）: 与SDK无关
         * @param {*} startTime 
         * @param {*} position 
         */

    }, {
        key: 'logService',
        value: function logService() {
            var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var data = {
                model: 'h5',
                reqid: 1, // 请求的ID
                lastloc: {
                    accu: -1, // 误差半径
                    age: new Date() - startTime,
                    lat: position.lat,
                    lon: position.lng,
                    coordtype: /wgs84/i.test(position.geoType) ? 0 : 1
                },
                version: '2.1.0', // 固定值
                address_language: '',
                appname: 'whereami',
                request_address: true,
                auth_key: 'GY7A10rxJfxi066yuEppbAJBSruNp6xt', // 授权码
                osver: '', // 系统版本号
                nettype: 'Mobile',
                deviceid: (0, _cookie2.default)('_hc.v')
            };
            (0, _xhr2.default)('//apimobile.meituan.com/locate/v2/sdk/loc?ci=whereami', [{
                name: 'Content-Type',
                value: 'application/json'
            }], data, function (e) {});
        }
    }, {
        key: 'randomSample',
        value: function randomSample(threshold) {
            if ((this.random || Math.random()) < threshold) {
                return true;
            }
            return false;
        }
    }, {
        key: 'withTag',
        value: function withTag(origin, tag) {
            var split = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

            if (!tag) return origin;
            if (!origin) return;
            return origin + split + tag;
        }
    }]);

    return Log;
}();

var instance = new Log();

module.exports.Log = instance.log.bind(instance);
module.exports.LogError = instance.logError.bind(instance);
module.exports.LogClean = instance.initData.bind(instance);

module.exports.LogService = instance.logService.bind(instance);


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/log.js
// module id = 495
// module chunks = 1 12 14